"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateTaxBreakdown = exports.calculateTaxBreakdownWithOptions = exports.roundPrice = exports.getCurrencySymbol = exports.amountToPriceString = exports.currencies = void 0;
const ts_pattern_1 = require("ts-pattern");
exports.currencies = ["GBP", "EUR", "AUD", "NZD", "SGD", "USD"];
const currencyToLocale = (currency) => (0, ts_pattern_1.match)(currency)
    .with("GBP", () => "en-GB")
    .with("EUR", () => "en-IE")
    .with("AUD", () => "en-AU")
    .with("NZD", () => "en-NZ")
    .with("SGD", () => "en-SG")
    .with("USD", () => "en-US")
    .otherwise(() => "");
const amountToPriceString = (currency, amount, amountInPennies = false) => {
    const value = Number(amount);
    if (currencyToLocale(currency))
        return new Intl.NumberFormat(currencyToLocale(currency), { style: "currency", currency, }).format(amountInPennies ? value / 100 : value);
    else
        return `¤${amountInPennies ? value / 100 : value}`;
};
exports.amountToPriceString = amountToPriceString;
const getCurrencySymbol = (currency) => {
    return (0, ts_pattern_1.match)(currency)
        .with("GBP", () => "£")
        .with("AUD", () => "$")
        .with("EUR", () => "€")
        .with("NZD", () => "$")
        .with("SGD", () => "$")
        .with("USD", () => "$")
        .otherwise(() => "");
};
exports.getCurrencySymbol = getCurrencySymbol;
const roundPrice = (num) => Math.round((num + Number.EPSILON) * 100) / 100;
exports.roundPrice = roundPrice;
const calculateTaxBreakdownWithOptions = (total, taxRate, options) => {
    return (0, exports.calculateTaxBreakdown)(total, taxRate, options.totalIncludesTax, options.decimalInput);
};
exports.calculateTaxBreakdownWithOptions = calculateTaxBreakdownWithOptions;
const calculateTaxBreakdown = (total, taxRate, totalIncludesTax, decimalInput) => {
    const isDecimalInput = typeof decimalInput === "boolean" ? decimalInput : true;
    if (totalIncludesTax && isDecimalInput) {
        const tax = (0, exports.roundPrice)(total - total / (1 + taxRate));
        const totalExTax = (0, exports.roundPrice)(total - tax);
        return { totalIncTax: total, tax, totalExTax };
    }
    else if (!totalIncludesTax && isDecimalInput) {
        const tax = (0, exports.roundPrice)(total * taxRate);
        const totalIncTax = (0, exports.roundPrice)(total + tax);
        return { totalIncTax, tax, totalExTax: total };
    }
    else if (totalIncludesTax && !isDecimalInput) {
        const tax = Math.round(total - total / (1 + taxRate));
        const totalExTax = total - tax;
        return { totalIncTax: total, tax, totalExTax };
    }
    else {
        const tax = Math.round(total * taxRate);
        const totalIncTax = total + tax;
        return { totalIncTax, tax, totalExTax: total };
    }
};
exports.calculateTaxBreakdown = calculateTaxBreakdown;
